import { axiosInventoryInstance } from '@/config/apiConfig';
import { AxiosResponse } from 'axios';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { IFetchMmsSales, IMmsSales } from './mmsSales.types';

// Define the Location interface representing the structure of the user object returned by the API

export const fetchMmsSales = ({
  page,
  limit,
  operatorId,
  locationId,
  marketId,
  startDate,
  endDate,
  order,
  orderBy,
  deviceId,
  dateFilterBy,
  isCompressed,
  sourceOrderId,
}: IFetchMmsSales): Promise<AxiosResponse<IMmsSales[], any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.MMS_SALES.GET_MMS_SALES,
    params: {
      page,
      limit,
      ...(operatorId !== '1' ? { operatorId } : {}),
      ...(locationId !== '1' ? { locationId } : {}),
      ...(deviceId !== '1' ? { deviceId } : {}),
      ...(marketId && marketId !== '1' ? { marketId } : {}),
      ...(sourceOrderId ? { sourceOrderId } : {}),
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
      ...(order ? { order } : {}),
      ...(orderBy ? { orderBy } : {}),
      isCompressed,
      dateFilterBy,
    },
  });
};

export const fetchMmsSalesRecordByOrderId = ({
  orderId,
}: IMmsSales): Promise<AxiosResponse<IMmsSales>> => {
  return axiosInventoryInstance.get(
    `${API_URL_CONFIG.MMS_SALES.GET_MMS_SALES}/${orderId}`,
  );
};
